/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import moment from 'moment'
import { history } from 'index'
import { notification } from 'antd'
import Cookies from 'js-cookie'
import jwt from 'jsonwebtoken'
import { setPageSize, setCurrentPage } from 'redux/settings/actions'
import { destroyCopilot } from 'services/copilotWidget'
import { isEmpty } from 'lodash'
import { ClockCircleOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { userRoleEnums } from 'enums/userRole'
import { downloadCSV as saveCSV } from './download'

export {
  downloadCSV,
  downloadAllPagesAsCSV,
  downloadExcelTemplate,
  fetchAllPaginatedRecords,
} from './download'

const TEMP_PASSWORD_RESET_REQUIRED_COOKIE = 'temporaryPasswordResetRequired'
const CURRENT_COMPANY_CODE_STORAGE_KEY = 'currentCompanyCode'
const SUBSCRIBED_FEATURES_STORAGE_KEY = 'subscribedFeatures'
const SUBSCRIPTION_DOWNLOAD_SETTINGS_STORAGE_KEY = 'subscriptionDownloadSettings'
export const TEMPLATE_DOWNLOAD_SETTING_KEY = 'is_template_download_flag'
export const CSV_DOWNLOAD_SETTING_KEY = 'is_CSV_Download_Flag'

const getStoredSubscribedFeatures = () => {
  let storedFeatures
  try {
    storedFeatures = window.localStorage.getItem(SUBSCRIBED_FEATURES_STORAGE_KEY)
  } catch (error) {
    storedFeatures = undefined
  }

  return storedFeatures || Cookies.get(SUBSCRIBED_FEATURES_STORAGE_KEY)
}

export const setStoredSubscribedFeatures = (features) => {
  try {
    window.localStorage.setItem(SUBSCRIBED_FEATURES_STORAGE_KEY, features)
    Cookies.remove(SUBSCRIBED_FEATURES_STORAGE_KEY)
  } catch (error) {
    Cookies.set(SUBSCRIBED_FEATURES_STORAGE_KEY, features, { expires: 1 })
  }
}

export const setStoredSubscriptionDownloadSettings = (features = []) => {
  const settingsByModule = (Array.isArray(features) ? features : []).reduce((settings, feature) => {
    const moduleKey = String(feature?.module_key || '')
      .trim()
      .toLowerCase()
    if (moduleKey) {
      settings[moduleKey] = Array.isArray(feature?.settings) ? feature.settings : []
    }
    return settings
  }, {})

  window.localStorage.setItem(
    SUBSCRIPTION_DOWNLOAD_SETTINGS_STORAGE_KEY,
    JSON.stringify(settingsByModule),
  )
}

const removeStoredSubscribedFeatures = () => {
  try {
    window.localStorage.removeItem(SUBSCRIBED_FEATURES_STORAGE_KEY)
  } catch (error) {
    // Ignore storage cleanup errors; cookie cleanup below is enough fallback.
  }
  Cookies.remove(SUBSCRIBED_FEATURES_STORAGE_KEY)
  try {
    window.localStorage.removeItem(SUBSCRIPTION_DOWNLOAD_SETTINGS_STORAGE_KEY)
  } catch (error) {
    // Ignore unavailable browser storage during logout.
  }
}

const ApiEndPoints = {
  GOOGLE_VERIFY_TOKEN: 'auth/verify-google-token',
  LOGIN: 'auth/login',
  MICROSOFT_VERIFY_TOKEN: 'auth/verify-token',
  REFRESH_TOKEN: 'auth/refresh-token',
  AUDIT_ACTIVITY_LOGS: 'audit-activity-logs',
  ATTENDANCE_SETTINGS: 'attendance-settings',
  ACCOUNT_SETTINGS: 'account-settings',
  ACCOUNT_SETTINGS_REFRESH: 'account-settings/refresh',
  SHIFT_MASTER: 'shift-master',
  SHIFT_MASTER_OPTIONS: 'shift-master/options',
  ROSTER_APPLICABLE_DEPARTMENTS: 'roster-applicable-departments',
  SEND_OTP: 'auth/send-otp',
  CHECK_EMPLOYEE_EMAIL: 'employee/verify-official-email',
  VERIFY_OTP: 'auth/verify-otp',
  SEND_RESET_PASSWORD_LINK: 'auth/send-reset-password-link',
  RESET_FORGOT_PASSWORD: 'auth/reset-forgot-password',
  REQUEST_SUBSCRIPTION_RENEWAL: 'auth/request-subscription-renewal',
  GLOBAL_TYPE_CATEGORY: 'globaltypecategory/',
  COMPANY_PROFILE: 'companyProfile/',
  GLOBAL_TYPE_CATEGORY_STATUS: 'globaltypecategory/status/',
  MASTER_GLOBAL_TYPE_CATEGORY: 'globaltype/masterglobaltype/',
  SINGLE_MASTER_GLOBAL_TYPE_CATEGORY: 'globalType/singleMasterGlobalType/',
  NESTED_GLOBAL_TYPE: 'globalType/nestedGlobaltype/',
  GLOBAL_TYPE: 'globaltype/',
  GLOBAL_TYPE_STATUS: 'globaltype/status/',
  GET_TRAINING_FOR: 'getTrainingFor/',
  LEAVE_POLICIES: 'leave-policies',
  COMP_OFF_ELIGIBILITY: 'comp-off-eligibility',
  REPORTS: 'reports',
  EMPLOYEE_APPLICABLE_LEAVE_POLICY: 'employees',

  MARK_LEAVE: 'employee/markLeave',
  UPDATE_LEAVE: 'employee/updateLeave',
  LEAVE_COUNT: 'employee/getLeaveCount',
  ALL_LEAVE: 'employee/allEmployee-leave',
  LEAVE_REQUEST: 'employee/leaveRequest',
  UPDATE_LEAVE_STATUS: 'employee/updateLeaveStatus',
  DELETE_LEAVE_REQUEST: 'employee/deleteLeaveRequest',
  GET_SINGLE_LEAVE_REQUEST: 'employee/getSingleRequestData',
  ALL_DAYOFF_LEAVE: 'employee/allEmployeeDay-leave',

  RAG_STATUS_LIST: 'employee/getRAGEmployee',
  UPDATE_RYG_EMPLOYEE: 'employee/updateRYGEmployee',
  RAG_COUNT: 'employee/RAGCount',
  RAY_COUNT_YEAR: 'employee/RAGYearReport',
  UPDATE_HIERARCHY: 'hierarchy/updateHierarchy',
  EVENTS: 'event/',
  CELEBRATIONS: 'event/celebrations',
  EVENT_CATEGORIES: 'event/categories',
  TEAM_LIST: 'teamList/',
  EXPENSES: 'expenses/',
  MEDIA: 'media/',
  EXPENSES_DOC: 'expensesDoc',
  REIMBURSMENT: 'reimbursement',
  REIMBURSMENT_DOC: 'reimbursementDoc',
}

export const utcToDate = (utc) => {
  const date = moment(utc).format('YYYY-MM-DD')
  return date
}
export const changeDateFormat = (value) => {
  const date = moment(value).format('YYYY/MM/DD')
  return date
}
export const utcToIst = (utc, format) => {
  let defaultFormat = 'h:mm A'
  if (format) {
    defaultFormat = format
  }
  const ist = moment.utc(utc).local().format(defaultFormat)
  return ist
}
export const capitalizeFirstLetter = (string) => {
  if (string === (undefined || null)) return null
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const formatDate = (date) => {
  const formattedDate = moment(date).format('YYYY-MM-DD')
  return moment(formattedDate, 'YYYY-MM-DD')
}

export const DateFormater = (date) => {
  const formattedDate = moment(date).format('YYYY-MM-DD')

  return formattedDate
}

export const MINIMUM_ONBOARDING_AGE = 18
export const ONBOARDING_AGE_VALIDATION_MESSAGE =
  'Employee must be at least 18 years old for onboarding.'

export const calculateAgeFromDateOfBirth = (value) => {
  if (!value) {
    return null
  }

  const dob = moment(value).startOf('day')

  if (!dob.isValid()) {
    return null
  }

  const today = moment().startOf('day')
  let age = today.year() - dob.year()

  if (today.month() < dob.month() || (today.month() === dob.month() && today.date() < dob.date())) {
    age -= 1
  }

  return age
}

export const getOnboardingAgeValidationMessage = (value) => {
  if (!value) {
    return ''
  }

  const age = calculateAgeFromDateOfBirth(value)

  if (age === null || age < MINIMUM_ONBOARDING_AGE) {
    return ONBOARDING_AGE_VALIDATION_MESSAGE
  }

  return ''
}
export const stripNonDigitCharacters = (value = '') => {
  return String(value).replace(/\D/g, '')
}

// Best-effort fallback for informal addresses the geocoder has no match for
// (e.g. "Gali No. 6B, Bunty Hotel, Mahipalpur, New Delhi-110037") — Indian PIN
// codes are always a standalone 6-digit run, so it can be pulled out reliably
// even when nothing else in the string can be safely parsed.
export const extractIndianPinCode = (value = '') => {
  const match = String(value).match(/\b(\d{6})\b/)
  return match ? match[1] : ''
}

export const normalizeDigitString = (value = '') => {
  const digits = stripNonDigitCharacters(value)

  if (!digits) {
    return ''
  }

  return digits.replace(/^0+(?=\d)/, '')
}

export const formatIndianNumberString = (value = '') => {
  const digits = normalizeDigitString(value)

  if (!digits) {
    return ''
  }

  if (digits.length <= 3) {
    return digits
  }

  const lastThreeDigits = digits.slice(-3)
  const remainingDigits = digits.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',')

  return `${remainingDigits},${lastThreeDigits}`
}

export const localToUTC = (date) => {
  return moment(date, 'YYYY-MM-DD').utc()
}
// Returns an array of dates between the two dates
export const getDates = (startDate, endDate) => {
  const date = new Date(startDate.getTime())

  const dates = []

  while (date <= endDate) {
    dates.push(new Date(date))
    date.setDate(date.getDate() + 1)
  }

  return dates
}

export const convertToCSV = (data) => {
  const header = `${Object.keys(data[0]).join(',')}\n`
  const rows = data.map((row) => `${Object.values(row).join(',')}\n`).join('')
  return header + rows
}

export const manageCSVDownload = (tableData) => {
  saveCSV({ data: tableData, fileName: 'Employee-Data.csv' })
}

export const formatLeaveUnits = (value) => {
  const numericValue = Number(value)

  if (!Number.isFinite(numericValue)) {
    return '0'
  }

  if (Number.isInteger(numericValue)) {
    return String(numericValue)
  }

  return numericValue.toFixed(1)
}

export const logoutUser = () => {
  destroyCopilot() // remove the copilot bubble on logout
  Cookies.remove('copilotEnabled')
  Cookies.remove('accessToken')
  Cookies.remove('refreshToken')
  Cookies.remove('permissions')
  removeStoredSubscribedFeatures()
  Cookies.remove(TEMP_PASSWORD_RESET_REQUIRED_COOKIE)
  history.push('/auth/login')
}

const displayErrorMsg = (error) => {
  notification.error({
    message: 'Error',
    description: error?.response?.data?.message,
  })
}
export const handelError = (error) => {
  if (error?.response?.data?.statusCode === (401 || 403)) {
    displayErrorMsg(error)
    logoutUser()
  } else {
    displayErrorMsg(error)
  }
}
export const generateYears = () => {
  const startYear = 2018
  const endYear = new Date().getFullYear()
  const years = []
  for (let year = startYear; year <= endYear; year += 1) {
    years.push({ label: year.toString(), value: year.toString() })
  }
  return years.reverse()
}
// export const Years = [
//   { label: '2023', value: '2023' },
//   { label: '2022', value: '2022' },
//   { label: '2021', value: '2021' },
//   { label: '2020', value: '2020' },
//   { label: '2019', value: '2019' },
//   { label: '2018', value: '2018' },
// ]
export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
export const monthArray = [
  { label: 'Jan', value: '01' },
  { label: 'Feb', value: '02' },
  { label: 'Mar', value: '03' },
  { label: 'Apr', value: '04' },
  { label: 'May', value: '05' },
  { label: 'Jun', value: '06' },
  { label: 'Jul', value: '07' },
  { label: 'Aug', value: '08' },
  { label: 'Sep', value: '09' },
  { label: 'Oct', value: '10' },
  { label: 'Nov', value: '11' },
  { label: 'Dec', value: '12' },
]
export const getYears = () => {
  const baseYear = 2024
  const currentYear = new Date().getFullYear()
  const startYear = Math.min(baseYear, currentYear)
  const endYear = currentYear + 5

  return [...Array(endYear - startYear + 1).keys()].map((year) => ({
    label: (startYear + year).toString(),
    value: startYear + year,
  }))
}

export const AnswerType = [
  { label: 'Subjective', value: 'subjective' },
  { label: 'MCQ', value: 'mcq' },
]
export const SelectionType = [
  { label: 'Single', value: 0 },
  { label: 'Multiple', value: 1 },
]

const normalizeAuthFlag = (value) => {
  if (typeof value === 'string') {
    const normalizedValue = value.trim().toLowerCase()

    if (normalizedValue === 'true') {
      return 1
    }

    if (normalizedValue === 'false') {
      return 0
    }
  }

  const numericValue = Number(value)
  if (Number.isNaN(numericValue)) {
    return 0
  }

  return numericValue ? 1 : 0
}

const normalizeUserRoleValue = (value) => {
  return value === 'super_admin' ? userRoleEnums?.ADMIN : value
}

const getStoredCompanyCode = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.localStorage.getItem(CURRENT_COMPANY_CODE_STORAGE_KEY)?.trim()?.toUpperCase() || ''
}

const normalizeEmployeeCodeWithCompanyCode = (empCode, companyCode) => {
  const normalizedEmpCode = String(empCode || '')
    .trim()
    .toUpperCase()
  const normalizedCompanyCode = String(companyCode || '')
    .trim()
    .toUpperCase()

  if (!normalizedEmpCode || !normalizedCompanyCode) {
    return normalizedEmpCode
  }

  const trailingDigits = normalizedEmpCode.match(/(\d{1,4})$/)?.[1]

  if (!trailingDigits) {
    return normalizedEmpCode
  }

  return `${normalizedCompanyCode}${trailingDigits.padStart(4, '0')}`
}

export const getEmployeeDisplayCode = (employee = {}) =>
  String(employee?.empCode || employee?.empId || employee?.empID || employee?.emp_code || '').trim()

export const getEmployeeDisplayLabel = (employee = {}) => {
  const employeeName = String(employee?.userName || '').trim()
  const employeeCode = getEmployeeDisplayCode(employee)

  if (employeeName && employeeCode) {
    return `${employeeName} (${employeeCode})`
  }

  return employeeName || employeeCode
}

export const getLoggedInUserInfo = () => {
  const token = Cookies.get('accessToken')
  const permissions = Cookies.get('permissions')
  const subscribedFeatures = getStoredSubscribedFeatures()
  if (token) {
    const decodedToken = jwt.decode(token)
    if (decodedToken?.userRole && decodedToken?.userId) {
      const userRole = normalizeUserRoleValue(decodedToken?.userRole)
      const userRoleId = decodedToken?.userRoleId
      const legacyOrNewEmpCode =
        decodedToken?.emp_code || decodedToken?.empCode || decodedToken?.empId
      const empCode = legacyOrNewEmpCode
        ? normalizeEmployeeCodeWithCompanyCode(legacyOrNewEmpCode, getStoredCompanyCode()) ||
          String(legacyOrNewEmpCode).toUpperCase()
        : undefined
      const userId = decodedToken?.userId
      const userName = decodedToken?.userName
      const email = decodedToken?.email?.toLowerCase()
      const locationId = decodedToken?.locationId
      const passwordResetRequired = normalizeAuthFlag(
        decodedToken?.password_reset_required ?? decodedToken?.passwordResetRequired,
      )
      const isTemporaryPassword = normalizeAuthFlag(
        decodedToken?.is_temporary_password ?? decodedToken?.isTemporaryPassword,
      )
      const hasSubscriptionScope = Boolean(
        decodedToken?.hasSubscriptionScope ?? decodedToken?.has_subscription_scope,
      )
      let userRoles = {}
      if (permissions !== undefined) {
        try {
          userRoles = JSON.parse(permissions)
        } catch (error) {
          userRoles = {}
        }
      }

      let subscribedFeatureList = []
      let subscribedModules = []
      if (subscribedFeatures !== undefined) {
        try {
          subscribedFeatureList = JSON.parse(subscribedFeatures)
          subscribedModules = [
            ...new Set(
              (Array.isArray(subscribedFeatureList) ? subscribedFeatureList : [])
                .flatMap((feature) => [feature?.module_key, feature?.parent_module_key])
                .map((moduleKey) => String(moduleKey || '').trim())
                .filter(Boolean),
            ),
          ]
        } catch (error) {
          subscribedFeatureList = []
          subscribedModules = []
        }
      }

      return {
        userRole,
        userRoleId,
        userId,
        empCode,
        empId: empCode,
        email,
        userRoles,
        subscribedFeatureList,
        subscribedModules,
        userName,
        locationId,
        password_reset_required: passwordResetRequired,
        is_temporary_password: isTemporaryPassword,
        hasSubscriptionScope,
      }
    }
  }
  return null
}

export const getSubscribedFeatureSetting = (moduleKey, settingName) => {
  const subscribedFeatureList = getLoggedInUserInfo()?.subscribedFeatureList || []

  const feature = subscribedFeatureList.find(
    (item) => String(item?.module_key || '').trim() === String(moduleKey || '').trim(),
  )

  if (!feature) {
    return null
  }

  if (settingName === 'display' && feature?.displayEnabled === true) {
    return feature?.display || null
  }

  if (!Array.isArray(feature?.settings)) {
    return null
  }

  const setting = feature.settings.find(
    (item) =>
      (item?.setting_name === settingName || item?.setting_key === settingName) &&
      item?.is_enabled === true,
  )

  return setting?.setting_value || null
}

export const getSubscribedFeatureDisplayName = (moduleKey, fallbackTitle) =>
  getSubscribedFeatureSetting(moduleKey, 'display') || fallbackTitle

const isSubscriptionFlagEnabled = (value) => value === true || Number(value) === 1
export const getSubscriptionDownloadFlags = (moduleKey) => {
  const normalizedModuleKey = String(moduleKey || '')
    .trim()
    .toLowerCase()
  let subscriptionSettings = {}
  try {
    subscriptionSettings = JSON.parse(
      window.localStorage.getItem(SUBSCRIPTION_DOWNLOAD_SETTINGS_STORAGE_KEY) || '{}',
    )
  } catch (error) {
    subscriptionSettings = {}
  }
  const settings = subscriptionSettings[normalizedModuleKey] || []
  const isEnabled = (settingKey) =>
    isSubscriptionFlagEnabled(
      settings.find(
        (setting) =>
          String(setting?.setting_key || '')
            .trim()
            .toLowerCase() === settingKey.toLowerCase(),
      )?.is_enabled,
    )

  return {
    isTemplateDownloadFlag: isEnabled(TEMPLATE_DOWNLOAD_SETTING_KEY),
    isCSVDownloadFlag: isEnabled(CSV_DOWNLOAD_SETTING_KEY),
  }
}

export const getProfileImageInfo = (value) => {
  if (!value || value === 'null' || value === 'undefined') {
    return null
  }

  let profileImage = value

  if (typeof value === 'string') {
    try {
      profileImage = JSON.parse(value)
    } catch (error) {
      return null
    }
  }

  if (Array.isArray(profileImage)) {
    profileImage = profileImage.find(Boolean)
  }

  if (!profileImage || typeof profileImage !== 'object') {
    return null
  }

  return profileImage?.id || profileImage?.mediaLink ? profileImage : null
}

export const isTemporaryPasswordResetRequired = (userInfo) => {
  const requiresResetFromToken =
    Number(userInfo?.password_reset_required) === 1 && Number(userInfo?.is_temporary_password) === 1
  const requiresResetFromCookie = Cookies.get(TEMP_PASSWORD_RESET_REQUIRED_COOKIE) === '1'

  return requiresResetFromToken || requiresResetFromCookie
}

export const setTemporaryPasswordResetRequired = (isRequired) => {
  if (isRequired) {
    Cookies.set(TEMP_PASSWORD_RESET_REQUIRED_COOKIE, '1', { expires: 1 })
    return
  }

  Cookies.remove(TEMP_PASSWORD_RESET_REQUIRED_COOKIE)
}
export const hourConversion = (minutes) => {
  if (!Number.isNaN(minutes)) {
    const hour = Math.floor(minutes / 60)
    const minute = minutes % 60
    return `${hour} Hours ${minute} Minutes`
  }
  return null
}
export const downloadPdf = (mediaLink) => {
  const protocol = window?.location?.protocol
  const baseURL =
    process.env.NODE_ENV === 'development' ? 'localhost:5000' : process.env.REACT_APP_PROD_BASE_URL
  // const downloadLink = `${protocol}//${baseURL}/${mediaLink}`
  const downloadLink =
    process.env.NODE_ENV === 'development'
      ? `${protocol}//${baseURL}/${mediaLink}`
      : `//${baseURL}/${mediaLink}`
  const fileName = downloadLink.split('/').pop()
  fetch(downloadLink)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => console.error('Error downloading PDF:', error))
}
const optionChildrenToString = (children) => {
  if (Array.isArray(children)) {
    return children.map(optionChildrenToString).join('')
  }
  if (children === null || children === undefined) {
    return ''
  }
  return String(children)
}

export const filterOption = (input, option) => {
  return optionChildrenToString(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
}

export const getSelectedDocumentMediaTypes = (documents = []) => {
  return documents
    ?.map((document) => document?.mediaType)
    .filter((mediaType) => typeof mediaType === 'string' && mediaType.trim())
}

export const getAvailableDocumentTypesForRow = ({
  documentTypes = [],
  documents = [],
  rowIndex,
}) => {
  const selectedMediaTypes = new Set(
    documents
      ?.filter((_, index) => index !== rowIndex)
      ?.map((document) => document?.mediaType)
      .filter((mediaType) => typeof mediaType === 'string' && mediaType.trim()),
  )
  const currentMediaType = documents?.[rowIndex]?.mediaType

  return documentTypes?.filter((documentType) => {
    const mediaType = documentType?.displayName

    if (!mediaType) {
      return false
    }

    return mediaType === currentMediaType || !selectedMediaTypes.has(mediaType)
  })
}

export const hasPendingDocumentTypes = ({ documentTypes = [], documents = [] }) => {
  const selectedMediaTypes = new Set(getSelectedDocumentMediaTypes(documents))

  return documentTypes?.some((documentType) => {
    const mediaType = documentType?.displayName

    return mediaType && !selectedMediaTypes.has(mediaType)
  })
}

export const resetPagination = { skip: 0, limit: 10 }
export const defaultPagination = (dispatch) => {
  dispatch(setCurrentPage(1))
  dispatch(setPageSize(10))
}

export const onPageChange = ({
  totalCount,
  pageSize,
  currentPage,
  oldPageSize,
  pageNumber,
  dispatch,
  handlePagination,
}) => {
  const lastPage = Math.ceil(totalCount / pageSize)
  if (currentPage !== pageNumber && pageNumber >= 1 && pageNumber <= lastPage) {
    const pageLimit = parseInt(pageNumber * oldPageSize, 10)
    const pageSkip = parseInt(pageLimit - oldPageSize, 10)
    dispatch(
      handlePagination({
        limit: pageLimit,
        skip: pageSkip,
      }),
    )
    dispatch(setCurrentPage(pageNumber))
  } else {
    dispatch(setCurrentPage(1))
  }
}

export const onPageSizeChange = ({ oldPageSize, pageSize, dispatch, handlePagination }) => {
  if (oldPageSize !== pageSize) {
    const pageLimit = parseInt(pageSize, 10)
    const pageSkip = parseInt(pageLimit - Number(pageSize), 10)
    dispatch(
      handlePagination({
        limit: pageLimit,
        skip: pageSkip,
      }),
    )
    dispatch(setPageSize(pageSize))
  }
}

export const Permissions = {
  READ: 'read',
  ADD: 'add',
  UPDATE: 'update',
  SHOW_ACTIVE_TOGGLE: 'show_active_toggle',
  DOWNLOAD_DATA: 'download_data',
  UPLOAD_DATA: 'upload_data',
  SEARCH_FILTERS: 'search_filters',
  WRITE: 'write',
}
export const ModuleUniqueValues = {
  EMPLOYEES: 'employees',
  ATTENDANCE: 'attendance',
  ATTENDANCE_SETTINGS: 'attendance_settings',
  ROSTER_MANAGEMENT: 'roster_management',
  ROSTER: 'roster',
  ROSTER_SHIFT_MASTER: 'roster_shift_master',
  ROSTER_ROTATION_RULES: 'roster_rotation_rules',
  SHIFT_TEAM_MAPPING: 'shift_team_mapping',
  WEEKLY_OFF_RULES: 'weekly_off_rules',
  DOWN_TIME: 'down_time',
  EXCEPTION: 'exception',
  GLOBAL_TYPE: 'global_type',
  GLOBAL_TYPE_CATEGORY: 'global_type_category',
  MODULE_PERMISSION: 'module_permission',
  TERMS_AND_CONDITION: 'terms_and_condition',
  COMPANY_POLICY: 'company_policy',
  LEAVE_POLICY: 'leave_policy',
  AGENTS: 'agents',
  DASHBOARD: 'dashboard',
  ROLE_AND_PERMISSIONS: 'role_and_permissions',
  HAPPY_TO_HELP: 'happy_to_help',
  RYG_STATUS: 'ryg_status',
  RESIGNATION: 'resignation',
  TALENT_ONBOARDING: 'talent_onboarding',
  ONBOARD: 'on_board',
  REIMBURSEMENT: 'reimbursement',
  FNF_SETTLEMENT: 'fnf_settlement',
  PAYROLL_SETTINGS: 'payroll_settings',
  PAYROLL_SETTINGS_MASTER: 'payroll_settings_master',
  PAYROLL_COMPLIANCE: 'payroll_compliance',
  SALARY_COMPONENT_MASTER: 'salary_component_master',
  SALARY_STRUCTURE_MASTER: 'salary_structure_master',
  ONBOARDATS: 'on_board_ats',
}

export const formHintBoxMessage = {
  PASSWORD: (
    <div style={{ padding: '5px', minWidth: '100px' }}>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 6 character long</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 1 upper letter</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 1 special symbol</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 1 number</p>
    </div>
  ),
  EMAIL: <p style={{ margin: 0, fontSize: '12px' }}>Enter a valid email for notification</p>,
  NAME: <p style={{ margin: 0, fontSize: '12px' }}>Name should be match your Id proof</p>,
  PHONE_NUMBER: <p style={{ margin: 0, fontSize: '12px' }}>Enter a valid mobile number</p>,
  COMMUNICATION_WITH: (
    <p style={{ margin: 0, maxWidth: '210px', fontSize: '12px' }}>
      To whom do you want to communicate in order to resolve your issue
    </p>
  ),
  CONCERN_DATE: <p style={{ margin: 0, fontSize: '12px' }}>Date related to issue invoke</p>,
  BELONGS_TO: <p style={{ margin: 0, fontSize: '12px' }}>Major field for issue</p>,
  DOWN_TIME: <p style={{ margin: 0, fontSize: '12px' }}>Reason for the down time</p>,
  RESIGNATION: <p style={{ margin: 0, fontSize: '12px' }}>Reason for the resignation</p>,
  UNIQUE_VALUE: (
    <div style={{ padding: '5px', maxWidth: '500px' }}>
      <p style={{ margin: 0, fontSize: '12px' }}>- Space will be treated as underscore</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Only string is allowed</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Max 30 character allowed</p>
    </div>
  ),
  MONTH_RECORD: (
    <p style={{ margin: 0, fontSize: '12px' }}>
      Click to see the month&apos;s attendance and scheduled roster-day record
    </p>
  ),
  TRAINING_END_DATE: (
    <p style={{ margin: 0, fontSize: '12px' }}>
      Training End Date will be changed according to the training duration
    </p>
  ),
  TRAINING_DURATION: (
    <p style={{ margin: 0, fontSize: '12px' }}>
      {' '}
      Training duration will be changed according to training type.
    </p>
  ),
}

export const CheckPermission = ({ moduleUniqueValue, permission, children }) => {
  const { userRole, userRoles, hasSubscriptionScope } = getLoggedInUserInfo()
  let showComponent = false
  if (!isEmpty(userRoles)) {
    const allPermissions = userRoles[moduleUniqueValue]
    showComponent = allPermissions?.includes(permission) || allPermissions?.includes('all')
  } else if (userRole === userRoleEnums?.ADMIN && !hasSubscriptionScope) {
    showComponent = true
  }

  return <>{showComponent ? children : null}</>
}

export const getColor = (status) => {
  switch (status) {
    case 0:
      return 'warning'
    case 1:
      return 'success'
    case 2:
      return 'processing'
    default:
      return 'error'
  }
}
export const getStatusLabel = (status) => {
  let color
  let displayStatus

  switch (status) {
    case 0:
      color = getColor(status)
      displayStatus = 'Pending'
      break
    case 1:
      color = getColor(status)
      displayStatus = 'Accepted'
      break
    case 2:
      color = getColor(status)
      displayStatus = 'Rejected'
      break
    case 3:
      color = getColor(status)
      displayStatus = 'Holiday'
      break
    case 'certified':
      color = 'green'
      displayStatus = 'Certified'
      break
    default:
      color = getColor(status)
      displayStatus = status
      break
  }

  return { color, displayStatus }
}
export const getAttendeanceLabel = (status) => {
  let color
  let displayStatus

  switch (status) {
    case 0:
      color = getColor(status)
      displayStatus = 'Absent'
      break
    case 1:
      color = getColor(status)
      displayStatus = 'Present'
      break
    case 2:
      color = getColor(status)
      displayStatus = 'Leave'
      break
    default:
      color = getColor(status)
      displayStatus = status
      break
  }

  return { color, displayStatus }
}
export const tooltip = (props) => {
  return props
}
export const uploadButtonContent = (
  <div>
    <p>Upload pdf only</p>
  </div>
)

// On Board round names
export const ONBOARDING_ROUND_CATEGORY = 'interview_round'
export const defaultOnboardingRoundLabels = ['HR Round', 'Technical Round', 'Client Round']

export const normalizeOnboardingRoundOptions = (rounds = [], { useFallback = true } = {}) => {
  const activeRounds = Array.isArray(rounds)
    ? rounds
        .filter(
          (round) => Number(round?.isActive ?? 1) === 1 && Number(round?.isDeleted ?? 0) !== 1,
        )
        .filter((round, index, source) => {
          const uniqueValue = round?.uniqueValue || round?.unique_value
          return (
            !uniqueValue ||
            source.findIndex(
              (candidate) => (candidate?.uniqueValue || candidate?.unique_value) === uniqueValue,
            ) === index
          )
        })
        .sort((left, right) => Number(left?.id || 0) - Number(right?.id || 0))
        .map((round, index) => ({
          label: round?.displayName || round?.name || `Round ${index + 1}`,
          value: Number.isInteger(round?.value) ? round.value : index,
          uniqueValue: round?.uniqueValue,
        }))
    : []

  if (activeRounds.length) return activeRounds

  return useFallback
    ? defaultOnboardingRoundLabels.map((label, index) => ({ label, value: index }))
    : []
}

export const getOnboardingRoundLabels = (rounds = []) =>
  normalizeOnboardingRoundOptions(rounds).map((round) => round.label)

// Step names
export const stepLabels = defaultOnboardingRoundLabels

// Status info
export const statusLabels = ['Pending', 'Accepted', 'Rejected']
export const statusColors = ['orange', 'green', 'red']
export const statusIcons = [
  <ClockCircleOutlined style={{ color: 'orange', fontSize: 20 }} />,
  <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />,
  <CloseCircleOutlined style={{ color: 'red', fontSize: 20 }} />,
]

// Utility to get latest step name
export const getLatestStepName = (steps = []) => {
  if (!steps || steps.length === 0) return ''
  const latestStep = [...steps].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]
  const snapshotRound = latestStep?.workflowRounds?.[latestStep?.step]
  if (snapshotRound)
    return snapshotRound.displayName || snapshotRound.name || `Step ${latestStep.step + 1}`
  return stepLabels[latestStep?.step] ?? `Step ${latestStep?.step + 1 || ''}`
}
export const StatusEnums = {
  APPROVED: 1,
  REJECTED: 2,
  PENDING: 0,
}
export const InterviewRoundEnums = {
  HR: 0,
  TECHNICAL: 1,
  CLIENT: 2,
}
export const getGifUrl = (eventName) => {
  const gifs = {
    birthday:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExcTFobzlnZnphdG91MW0wb2dobzd2MG55MDNwbG9ydDI1OTIzMDBubyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/LzwcNOrbA3aYvXK6r7/giphy.webp',
    'work anniversary':
      'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExcWEyNno2aGJyM2J2dTNkcjRodzBjdTR5bGVjYWg3N2VydjA3d244cSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/aBdynNoIroNBE81ztM/giphy.webp',
    christmas:
      'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExNXlpY3A4ZThmYmE0eXFnYTVjM3JtZ2JxOHZ3OGg1bnR6MnduNXk5YiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gNke2UrUTopOg/giphy.webp',
    holi: 'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExeXdiNjRrZXlhMDQ1YXFraHJzenBmMXEzZGdnN2QyNDJiNWk5bThwcyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Kgg2uQR7kGzahkdhLZ/giphy.webp',
    foundation:
      'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3A5aGk4ZXJqbWg3N2E0bzZlZW9mYnpsbDlqOHEwZ3dyNWpyY2w1bSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/54Ya4OpMWF9Es5sTSZ/giphy.webp',
    environment:
      'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExMGJqNmUyeDQ4cnAxdjZsN3p4aXFzamNzYXQ3ZDQ3NDJqenBwc2Q0NSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gmMdx28Sc9KwwciP6z/giphy.webp',
  }

  const normalizedEventName = eventName.trim().toLowerCase()

  if (normalizedEventName.includes('birthday')) {
    return gifs.birthday
  }
  if (normalizedEventName.includes('work anniversary')) {
    return gifs['work anniversary']
  }
  if (normalizedEventName.includes('christmas')) {
    return gifs.christmas
  }
  if (normalizedEventName.includes('holi')) {
    return gifs.holi
  }
  if (normalizedEventName.includes('foundation')) {
    return gifs.foundation
  }
  if (normalizedEventName.includes('environment')) {
    return gifs.environment
  }
  return 'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZWM1MWs5anZodmgzendtbzBobzRjZzk2NjI5eGpiMGFrM3AyN3NrNiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/GNU2daXX1y4PGX8cWZ/giphy.webp'
}

export default ApiEndPoints
